import { Calificaciones } from '../../../../constants/enums';

const validatePercentage = (value = 0) => parseFloat(value) < 0 || parseFloat(value) > 100;

const validate = (values) => {
  const attrs = values || {};
  const errors = {};

  if (!attrs.alumnoObj || !attrs.alumnoObj.value) {
    errors.alumnoObj = 'Debe seleccionar el alumno';
  }
  if (!attrs.fechaInscripcion) {
    errors.fechaInscripcion = 'Debe ingresar la fecha';
  }

  if (validatePercentage(attrs.porcentajeAsistencia)) {
    errors.porcentajeAsistencia = 'Debe ingresar valor en el rango 0 - 100';
  }
  if (validatePercentage(attrs.porcentajePP)) {
    errors.porcentajePP = 'Debe ingresar valor en el rango 0 - 100';
  }
  if (validatePercentage(attrs.porcentajePF)) {
    errors.porcentajePF = 'Debe ingresar valor en el rango 0 - 100';
  }
  if (validatePercentage(attrs.porcentajePC)) {
    errors.porcentajePC = 'Debe ingresar valor en el rango 0 - 100';
  }

  if (
    !attrs.calificacionObj
    || !Number.isInteger(attrs.calificacionObj.value)
    || !Calificaciones.some(ca => ca.value === attrs.calificacionObj.value)) {
    errors.calificacionObj = 'Valor requerido';
  }
  return errors;
};

export default validate;
